/**
 * V2QsSelectSheet 컴포넌트 Props 인터페이스
 * V1 QsInputSelectSheet의 V2 버전 (순수 UI만)
 *
 * 바텀시트 모달을 통한 선택 컴포넌트
 */

/**
 * 선택 옵션 아이템
 */
export interface V2QsSelectSheetOption {
  /**
   * 옵션 고유 키
   */
  key: string;

  /**
   * 표시할 라벨 (번역된 텍스트)
   */
  label: string;

  /**
   * 선택 시 추가 노트 입력 필요 여부
   */
  requireNote?: boolean;

  /**
   * 상호 배타적 옵션 여부 (선택 시 다른 옵션 해제)
   */
  mutualExclusive?: boolean;

  /**
   * 비활성화 여부
   */
  disabled?: boolean;
}

/**
 * 선택된 값
 */
export interface V2QsSelectSheetValue {
  /**
   * 선택된 옵션 키 배열
   */
  selectedKeys: string[];

  /**
   * 옵션별 추가 노트
   */
  notesForKeys?: Record<string, string>;
}

export interface V2QsSelectSheetProps {
  /**
   * 선택 옵션 목록
   */
  options: V2QsSelectSheetOption[];

  /**
   * 현재 선택된 값
   */
  value?: V2QsSelectSheetValue;

  /**
   * 값 변경 시 콜백
   */
  onChange?: (value: V2QsSelectSheetValue) => void;

  /**
   * 단일 선택 모드 (기본: false = 다중 선택)
   */
  single?: boolean;

  /**
   * 모달 열림 상태 (외부 제어용)
   */
  isOpen?: boolean;

  /**
   * 모달 열기 콜백
   */
  onOpen?: () => void;

  /**
   * 모달 닫기 콜백
   */
  onClose?: () => void;

  /**
   * 비활성화 여부
   */
  disabled?: boolean;

  /**
   * 읽기 전용 여부
   */
  readOnly?: boolean;

  /**
   * 에러 상태
   */
  hasError?: boolean;

  /**
   * 에러 메시지
   */
  errorMessage?: string;

  /**
   * RTL 모드
   */
  isRtl?: boolean;

  // i18n 텍스트 Props
  /**
   * 모달 제목
   */
  title?: string;

  /**
   * 플레이스홀더 텍스트
   */
  placeholder?: string;

  /**
   * 닫기 버튼 텍스트
   */
  closeButtonText?: string;

  /**
   * 노트 입력 플레이스홀더
   */
  notePlaceholder?: string;

  /**
   * 노트 필수 입력 경고 메시지
   */
  noteRequiredMessage?: string;

  /**
   * 추가 CSS 클래스
   */
  className?: string;

  /**
   * 입력 필드 추가 CSS 클래스
   */
  inputClassName?: string;

  /**
   * 모달 추가 CSS 클래스
   */
  modalClassName?: string;
}

export const defaultV2QsSelectSheetProps: Partial<V2QsSelectSheetProps> = {
  single: false,
  disabled: false,
  readOnly: false,
  hasError: false,
  isRtl: false,
  placeholder: 'Select',
  closeButtonText: 'Close',
  notePlaceholder: 'Describe in detail',
  noteRequiredMessage: 'Detailed description required',
};
